var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticStyle:{"text-align":"center","margin":"10%"}},[_c('h1',[_vm._v("Немає такого!!!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }